{
  "version": 1,
  "asset_id": "18b44cb1-df0b-4a4e-88e5-4ec3fb3aef25",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/18b44cb1-df0b-4a4e-88e5-4ec3fb3aef25/loc-san-antonio-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/18b44cb1-df0b-4a4e-88e5-4ec3fb3aef25/loc-san-antonio-1280.avif",
  "original_filename": "loc-san-antonio-1280.avif",
  "size": 95121,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:34Z"
}
